// extracted by mini-css-extract-plugin
module.exports = {"truncated":"layout_truncated__DEiWO","body":"layout_body__Qb93j","page":"layout_page__QQMTI","row":"layout_row__Ae7Q6"};